import { render, staticRenderFns } from "./dgd-banner.vue?vue&type=template&id=ea7bd1be&scoped=true&"
import script from "./dgd-banner.vue?vue&type=script&lang=js&"
export * from "./dgd-banner.vue?vue&type=script&lang=js&"
import style0 from "./dgd-banner.vue?vue&type=style&index=0&id=ea7bd1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7bd1be",
  null
  
)

export default component.exports